<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)" class="sitebuilder-element-container"
    element="SimpleFormComponent" :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile" :config-properties="JSON.stringify(internal_config)"
    :style="style()" v-on:click="focusElement($event)">
    <delete-confirmation-modal ref="discardCaptcha" :custom="true" :title="$t('discard')"
      :message="$t('ct-remove-recaptcha-confirm')" :confirmMessage="$t('ct-remove')" @confirm="saveReCaptcha('', '')" />

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize" :draggable="false" ref="draggableResizable">
      <sync-drag :target="this" />
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-SimpleFormComponent'>
        <img src="static/images/icons/engrenagem.svg" class="svg-icon normal-action"
          v-tooltip="{content:$t('ct-option-set-fields'),  class: 'tooltip-custom'}" @click="changeFields" />

        <img src="static/images/icons/list.svg" class="svg-icon normal-action" v-show="!internal_config.horizontal"
          v-tooltip="{content:$t('ct-option-grid'),  class: 'tooltip-custom'}" @click="changeColumns" />


        <img src="static/images/icons/list.svg" class="svg-icon normal-action" v-show="internal_config.horizontal"
          v-tooltip="{content:$t('ct-option-grid'),  class: 'tooltip-custom'}" @click="horizontalColumns" />

        <img src="static/images/icons/social-proof-option.svg" class="svg-icon normal-action"
          v-tooltip="{content:$t('ct-option-socialproof'),  class: 'tooltip-custom'}" @click="openSocialProof" />
        <img v-if="internal_config.recaptchaSiteKey" class="svg-icon normal-action" src="static/images/icons/delete.svg"
          v-tooltip="{content:$t('ct-option-remove-recaptcha'),  class: 'tooltip-custom'}" @click="clearRecaptcha()" />
        <img v-else class="svg-icon normal-action" src="static/images/icons/recaptcha.svg"
          v-tooltip="{content:$t('ct-option-set-recaptcha'),  class: 'tooltip-custom'}" @click="openModalRecaptcha()" />
      </options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>
      <form :class="horizontal ? 'form-simple horizontal-form': 'form-simple'" :target="internal_config.target"
        method="post" ref="form" :action="internal_config.action" :receiver="internal_config.receiver"
        :subject="internal_config.subject">
        <div class="inputs-area" ref="container"></div>
        <div class="recaptcha-container" v-if="internal_config.recaptchaSiteKey">
          <vue-recaptcha :sitekey="internal_config.recaptchaSiteKey"></vue-recaptcha>
        </div>
         <altcha-widget v-if="!internal_config.recaptchaSiteKey" id="altchaWidget" class="altchaWidget" :challengejson="challengeJson"
                hidefooter auto
                style="--altcha-border-radius: 5px; --altcha-max-width: 350px; --altcha-color-base: #f0f0f088;" />
        <div class="place-btn" :style="{ margin: buttonMargin}">
          <div class="bt-sb" v-bind:style="{
                        width : buttonWidth,
                        'box-shadow': buttonBoxShadow,
                        border : buttonBorder,
                        'border-radius': buttonRadius,
                        background: buttonBackground,
                        }">
            <div class="bt-text-area d-flex align-items-center flex-wrap overflow-hidden"
              :style="{ minHeight: buttonHeight }">
              <a v-on:click="submit($event)" class="sb-text" :style="textStyle()">{{internal_config.button.text}}</a>
              <small class="sb-sub-text" v-if="internal_config.button.subText"
                :style="subTextStyle()">{{internal_config.button.subText}}</small>
            </div>
          </div>
        </div>
      </form>

      <resources ref="resourcesData"></resources>

    </vue-draggable-resizable>
  </div>
</template>

<script>

import Vue from 'vue';
import Data from './Model';
import Resources from './Resources.vue';

import VueRecaptcha from 'vue-recaptcha';

import CheckFields from '../Fields/CheckFields.vue';
import SelectFields from '../Fields/SelectFields.vue';
import TextFields from '../Fields/Text.vue';
import DateFields from '../Fields/DateFields.vue';
import OptionsElementBar from "../../OptionsElementBar";
import ReCaptcha from "../../../resources/ReCaptcha";
import MixinForm from "../MixinForm.js";
import { loadAltcha } from '../../../../../js/services/integrations-internas/captcha';

export default {
  name: 'SimpleFormComponent',
  props: ['config', 'id', 'preview', 'device'],
  mixins: [MixinForm],
  components: {
    OptionsElementBar,
    Resources,
    CheckFields,
    SelectFields,
    TextFields,
    DateFields,
    VueRecaptcha,
    ReCaptcha
  },
  computed: {
    horizontal() {
      return this.internal_config.horizontal;
    },

    buttonWidth() {
      return parseInt(this.internal_config.button.width) + '%';
    },
    buttonHeight() {
      return parseInt(this.internal_config.button.height) + 'px';
    },
    buttonBorder() {
      return this.internal_config.button.border;
    },
    buttonBoxShadow() {
      return this.internal_config.button.boxShadow;
    },
    buttonRadius() {
      return this.internal_config.button.borderRadius;
    },
    buttonBackground() {
      let bg = this.internal_config.button.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
        bg += ' url("' + this.internal_config.button.backgroundImage + '")';
        bg += ' ' + this.internal_config.button.backgroundPosition;
        bg += ' / ' + this.internal_config.button.backgroundSize;
        bg += ' ' + this.internal_config.button.backgroundRepeat;
        bg += ' ' + this.internal_config.button.backgroundOrigin;
      }

      return bg;
    },
    buttonMargin() {
      const horizontal = this.internal_config.horizontal
      const margin = this.internal_config.button.margin

      return horizontal ? `0px 0px 0px ${margin}px` : `${margin}px 0px 0px`
    }
  },
  data() {
    return Data.data();;
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },

  methods: {
    animation() {
      return true;
    },
    animateField() {
      this.internal_config.fieldAnimated = true;
    },

    verifyRequired() {
      if (this.internal_config.newField.required == 'no') {
        this.$refs.visibilyField.style.display = 'block';
        this.$refs.visibilyFieldOption.style.display = 'block';
      } else {
        this.$refs.visibilyField.style.display = 'none';
        this.$refs.visibilyFieldOption.style.display = 'none';
      }
    },
    setColumns() {

      let container = this.$el.querySelector('.inputs-area');

      if(this.internal_config.columns <= 1) {
        container.classList.remove("row");

        container.querySelectorAll('.form-group').forEach( input => {
          for(let i = 1; i <= 12; i++) {
            input.parentElement.classList.remove("col-" + i);
          }
        } )

      } else {

         container.classList.add("row");

          container.querySelectorAll('.form-group').forEach( input => {
             for(let i = 1; i <= 12; i++) {
                input.parentElement.classList.remove("col-" + i);
              }
            input.parentElement.classList.add(`col-${12 / this.internal_config.columns}`);
          } )

      }


    },
    changeFields() {
      // $('*')
      //   .filter(function() {
      //     return $(this).css('z-index') == 500;
      //   })
      //   .each(function() {
      //     $(this).css('z-index', 499);
      //   });
      // $(this.$el).css({zIndex: 500});
      // this.$refs.modal.open();
      this.$root.$emit('openSimpleFormModal', this.internal_config, 'config', this.save);
    },
    submit(e) {
      e.preventDefault();

      const inputs = this.$refs.form.querySelectorAll('input');

      for (let i = 0; i < inputs.length; i++) {
        const x = inputs[i];

        if (x.getAttribute('validation') === 'fullname') {
          const regex = /^[a-zA-Z]{2,}\s+[a-zA-Z]{2,}(?:\s+[a-zA-Z]{2,})*$/;

          if (!regex.test(x.value)) {
            this.$snotify.warning(this.$t('ct-please-enter-valid-full-name'));
            return false;  // Interrompe o loop e a execução da função
          }
        }
      }

      this.$refs.form.submit();
    },
    save(config) {
      this.internal_config = Object.assign({}, this.internal_config, config);
      this.buildFields(this);
      $(this.$el).css({zIndex: this.internal_config.zIndex});
      // this.$refs.modal.close();
    },
    buildFields: function(vm) {
      this.$refs.container.innerHTML = '';

      vm.internal_config.fields.forEach(field => {
        let identifier = field.field;
        if (typeof identifier === 'undefined') {
          identifier = 'text';
        }

        if (identifier === 'textarea') vm.createTextField(field, true);
        if (identifier === 'text') vm.createTextField(field, false);
        if (identifier === 'password') vm.createTextField(field, false, true);
        if (identifier === 'select') vm.createDropDown(field, false);
        if (identifier === 'multiselect') vm.createDropDown(field, true);
        if (identifier === 'dropdown') vm.createDropDown(field, false);
        if (identifier === 'datetime') vm.createDateTime(field, true);
        if (identifier === 'date') vm.createDateTime(field, false);
        if (identifier === 'checkbox') vm.createCheckField(field, 'checkbox');
        if (identifier === 'radio') vm.createCheckField(field, 'radio');
      });

      this.inputStyle();
      this.$loading.hide();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);


      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    edit(e) {
      e.preventDefault();
      this.internal_config.src = prompt('src', this.internal_config.src);
    },

    textStyle() {
      let sizeMobile = typeof this.internal_config.button.textStyle.sizeMobile !== 'undefined' && this.internal_config.button.textStyle.sizeMobile ?
        this.internal_config.button.textStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.button.textStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.button.textStyle.size};
                 text-align: ${this.internal_config.button.textStyle.align};
                 font-weight: ${this.internal_config.button.textStyle.weight};
                 font-style: ${this.internal_config.button.textStyle.style};
                 color: ${this.internal_config.button.textStyle.color}`;
    },

    subTextStyle() {
      let sizeMobile = typeof this.internal_config.button.subTextStyle.sizeMobile !== 'undefined' && this.internal_config.button.subTextStyle.sizeMobile ?
        this.internal_config.button.subTextStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.button.subTextStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.button.subTextStyle.size};
                 text-align: ${this.internal_config.button.subTextStyle.align};
                 font-weight: ${this.internal_config.button.subTextStyle.weight};
                 font-style: ${this.internal_config.button.subTextStyle.style};
                 color: ${this.internal_config.button.subTextStyle.color}`;
    },
    buildIcon: function() {
      $(this.$el)
        .find('i')
        .detach();

      if (this.internal_config.button.icon !== '') {
        if (this.internal_config.button.iconPosition === 'left') {
          $('<i>')
            .addClass(this.$addIconPrefix(this.internal_config.button.icon))
            .prependTo(
              $(this.$el)
                .find('.sb-text')
                .get(0)
            );
        }
        if (this.internal_config.button.iconPosition === 'right') {
          $('<i>')
            .addClass(this.$addIconPrefix(this.internal_config.button.icon))
            .appendTo(
              $(this.$el)
                .find('.sb-text')
                .get(0)
            );
        }
      }
    },
    build(config) {
      this.internal_config = config;

      this.buildIcon();
    },
    style() {
      return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    createCheckField(field, type) {
      let ComponentClass = Vue.extend(CheckFields);
      let instance = new ComponentClass({
        propsData: {
          type: type,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          label: field.label,
          options: field.options,
          selected: [],
          data: field
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    createDropDown(field, multiple) {
      let ComponentClass = Vue.extend(SelectFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          options: field.options,
          selected: field.default_value,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          data: field,
          multiple: multiple
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    createDateTime(field, useCurrent) {
      let ComponentClass = Vue.extend(DateFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          data: field,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          value: new Date().toString(),
          type: useCurrent ? 'datetime' : 'date',
          icon: field.icon,
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    createTextField(field, area, pass) {
      let ComponentClass = Vue.extend(TextFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          value: field.default_value,
          pass: pass,
          color: this.internal_config.inputStyle.color,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          icon: field.icon,
          data: field,
          area: area,
          validation: field.validation
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    inputStyle() {
      let vm = this;

      let elements = this.$refs.container.getElementsByClassName(
        'form-control'
      );
      [].forEach.call(elements, function(el) {
        el.style.backgroundColor = vm.internal_config.inputBgColor;
        el.style.border = vm.internal_config.inputBorder;

        if(el.tagName === 'TEXTAREA' && vm.internal_config.textareaHeight) {
          el.style.height = vm.internal_config.textareaHeight;
          el.classList.add('form-control-textarea-has-height');
        } else {
          el.style.height = vm.internal_config.inputHeight;
        }
        el.style.borderRadius = vm.internal_config.inputRadius;

        el.style.fontFamily = vm.internal_config.inputStyle.family;
        el.style.fontSize = vm.internal_config.inputStyle.size;
        el.style.textAlign = vm.internal_config.inputStyle.align;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.color = vm.internal_config.inputStyle.color;
      });
      vm.$el.style.color = vm.internal_config.labelStyle;
    },
    placeholderStyle() {
      const elements = this.$refs.container.getElementsByClassName(
        'form-control'
      );

      for (let element of elements) {
        element.style.setProperty('--placeholder-color', this.internal_config.placeholderColor || '#5c5c5c');
      }
    },
    changePosition(index, newIndex) {
      if (newIndex >= this.internal_config.fields.length || newIndex < 0) {
        return;
      }

      this.animateField();
      this.internal_config.fields.splice(
        newIndex,
        0,
        this.internal_config.fields.splice(index, 1)[0]
      );
    },
    saveReCaptcha(siteKey, secretKey) {
      this.internal_config.recaptchaSiteKey = siteKey;
      this.internal_config.recaptchaSecretKey = secretKey;
      this.$snotify.success(this.$t('ct-saved'));
    },

    clearRecaptcha() {
      this.$refs.discardCaptcha.open();
    },

    openSocialProof() {
      this.$root.$emit('openFormConfigSocialProofConfigModal', this.internal_config, 'simple-form', 'fields', (config) => {
        this.internal_config = Object.assign({}, this.internal_config, config);
      });
    },

    openModalRecaptcha() {
      this.$root.$emit('showReCaptcha', this.internal_config.recaptchaSiteKey,this.internal_config.recaptchaSecretKey,this.saveReCaptcha)
    },
    async loadingAltcha() {
      try {
        const { data } = await loadAltcha();

        this.challengeJson = JSON.stringify(data);
      } catch (error) {
        console.error('Falha ao carregar ALTCHA Captcha:', error);
      }
    }

  },

  created() {
    if (typeof this.config.horizontal_config_mobile === 'undefined' && typeof this.config.horizontal_config !== 'undefined') {
      this.$props.config.horizontal_config_mobile = Object.assign({}, this.config.horizontal_config);
    }

    if (typeof this.config.button.textStyle.sizeMobile === 'undefined' || this.config.button.textStyle.sizeMobile === '') {
      this.$props.config.button.textStyle.sizeMobile = this.config.button.textStyle.size;
    }

    if (typeof this.config.button.subTextStyle.sizeMobile === 'undefined' || this.config.button.subTextStyle.sizeMobile === '') {
      this.$props.config.button.subTextStyle.sizeMobile =this.config.button.subTextStyle.size;
    }
  },

  mounted() {


    let vm = this;

    this.build(this.$props.config);

    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );

    this.internal_config.button.subText = this.internal_config.button.subtext;

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      this.$el.classList.add('preview');

      this.$el.addEventListener('mouseover', function() {
        document.body.style.setProperty(
          '--button-background-color--hover',
          vm.internal_config.button.backgroundColorHover
        );
        document.body.style.setProperty(
          '--button-text-color--hover',
          vm.internal_config.button.textColorHover
        );
      });
    }

    this.buildFields(this);

    this.inputStyle();
    this.placeholderStyle()

    this.setColumns()

    this.testAlan(this.internal_config.horizontal_config, this.internal_config.horizontal_config_mobile)


    let objIds = [];
    $('[id]').each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) {
        objIds.push(this.id);
      }
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if(this.id == id){
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$refs.resourcesData.setValuesData(this);

    this.loadingAltcha();
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sitebuilder-element-container .vdr,
.vdr,
.bt-sb,
form.form-simple {
  height: auto !important;
}

.preview .bt-sb:hover {
  cursor: pointer;
  background-color: var(--button-background-color--hover) !important;

  * {
    color: var(--button-text-color--hover) !important;
  }
}

.place-btn {
  text-align: center;

  .bt-sb {
    display: inline-block;
  }

  .sb-text,
  .sb-sub-text{
    width: 100%;
  }
}

.bt-text-area {
  display: block;
}

[data-device="tablet"] .bt-text-area,
[data-device="mobile"] .bt-text-area {
  width: auto !important;
}
</style>
<style lang="scss">

label{
  max-width: 100%;
  word-wrap: break-word
}

input.form-control, textarea.form-control {
  &::placeholder {
    color: var(--placeholder-color);
  }
}

.list-item {
  display: block;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 5px;
  margin-top: 2px;
  cursor: pointer;
}

.list-item.selected {
  border: 1px solid blue;
}


.altchaWidget{
  display: flex;
	justify-content: center;
		.altcha{
    		margin-bottom: 1rem !important;
			.altcha-main{
				gap: 1rem !important;
				padding: .6rem 1rem !important;
			}
    }
  body {
    background-color: #fff;
}

.subtitle {
    font-weight: 400;
    font-size: 18px;
    margin-top: 8px;
    margin-bottom: 28px;
}

.description {
    font-weight: 400;
    font-size: 18px;
    margin-top: 68px;
}

footer {
    border-top: 1px solid #b0b0b0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 2vh;
    margin: 0px 15%;
}

footer span {
    margin-top: 5px;
    color: #b0b0b0;
}

.container {
    margin: 12vh 15%;
    height: calc(100vh - 28vh);
}

.sub-container {
    display: flex;
    flex-direction: column;
}

.altcha-label {
    font-size: 18px;
    margin-bottom: 0px !important;
}

.altcha-checkbox {
    width: 24px !important;
}

.altcha-checkbox input {
    width: 24px !important;
    height: 24px !important;
}

.altcha-logo svg {
    display: none;
}
.altcha-logo::before {
    display: flex;
    align-items: center;
    justify-content: center;
    content: '';
    width: 50px;
    height: 50px;
    top: 10px !important;
    position: relative;
    background-image: none;
    background-size: contain;
    background-repeat: no-repeat;
}

}


</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/SimpleForm/SimpleForm.vue